<template>
  <theme-comp-switch
    v-bind="$attrs"
    v-on="$listeners"
    :defaultComp="defaultModal"
    :lalamoveComp="lalamoveModal"
  >
    <slot></slot>
  </theme-comp-switch>
</template>

<script>
export default {
  data() {
    return {
      defaultModal: () => import('./HllModal.vue'),
      lalamoveModal: () => import('./LalamoveModal')
    };
  }
};
</script>
